import { useState } from "react";

export const useCalendar = () => {
  // Estado para controlar qué menú de calendario está abierto
  const [openCalendarMenu, setOpenCalendarMenu] = useState(null);

  // Formato de fecha para ICS: YYYYMMDDTHHMMSSZ
  const formatICSDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().replace(/-|:|\.\d+/g, "");
  };

  // Generar archivo ICS
  const generateICSFile = (event) => {
    const startDate = formatICSDate(event.data);

    // Asumimos que el evento dura 2 horas, ajusta según tus necesidades
    const endDate = formatICSDate(
      new Date(new Date(event.data).getTime() + 2 * 60 * 60 * 1000)
    );

    // Creamos el contenido del archivo ICS
    const icsContent = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "CALSCALE:GREGORIAN",
      "METHOD:PUBLISH",
      "BEGIN:VEVENT",
      `SUMMARY:${event.titol}`,
      `DESCRIPTION:${event.descripcio}`,
      `DTSTART:${startDate}`,
      `DTEND:${endDate}`,
      `LOCATION:La Flama`,
      "STATUS:CONFIRMED",
      `UID:${new Date().getTime()}@laflama.cat`,
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n");

    return icsContent;
  };

  // Función para descargar el archivo ICS
  const downloadICS = (event) => {
    const icsContent = generateICSFile(event);
    const blob = new Blob([icsContent], {
      type: "text/calendar;charset=utf-8",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `evento-laflama-${event.titol
      .replace(/\s+/g, "-")
      .toLowerCase()}.ics`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Generar URL para Google Calendar
  const generateGoogleCalendarURL = (event) => {
    const startDate = new Date(event.data);
    const endDate = new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // 2 horas de duración

    const formatGoogleDate = (date) => {
      return date.toISOString().replace(/-|:|\.\d+/g, "");
    };

    const params = new URLSearchParams({
      action: "TEMPLATE",
      text: event.titol,
      details: event.descripcio,
      location: "La Flama",
      dates: `${formatGoogleDate(startDate)}/${formatGoogleDate(endDate)}`,
    });

    return `https://calendar.google.com/calendar/render?${params.toString()}`;
  };

  // Gestionar clic en "AFEGIR AL MEU CALENDARI"
  const handleCalendarClick = (event, index, e) => {
    e.preventDefault();
    setOpenCalendarMenu(openCalendarMenu === index ? null : index);
  };

  // Cerrar el menú del calendario
  const closeCalendarMenu = () => {
    setOpenCalendarMenu(null);
  };

  // Añadir al calendario Apple/Outlook
  const addToAppleOutlookCalendar = (event) => {
    downloadICS(event);
    closeCalendarMenu();
  };

  // Obtener URL para Google Calendar
  const getGoogleCalendarURL = (event) => {
    return generateGoogleCalendarURL(event);
  };

  return {
    openCalendarMenu,
    handleCalendarClick,
    closeCalendarMenu,
    addToAppleOutlookCalendar,
    getGoogleCalendarURL,
  };
};
